import { Component, OnInit, Input } from '@angular/core'
import { RichsnipetService } from 'dmmp-services'


@Component({
  selector: 'dmmp-faq-section',
  templateUrl: './faq-section.component.html',
})
export class FaqSectionComponent implements OnInit {
  @Input() data
  @Input() layout
  @Input() identifier
  schema: object

  constructor(private richsnipetService: RichsnipetService) {}

  ngOnInit(): void {
    this.schema = this.richsnipetService.setupJsonFaq(this.data?.content?.faqs)
  }
}
